<template>

  <div class="service-page">
<!--        <div class="title">-->
<!--          <van-nav-bar title="互联网医院资质图片" left-arrow @click-left="onClickLeft"/>-->
<!--        </div>  -->
        <div class="text">营业执照</div>
        <div style="text-align: center;">
            <img class="img" alt="" src="@/icons/qualificationImage1.jpg" @click="onClick(0)"/>
        </div>
        <div class="text">医疗机构执业许可证</div>
        <div style="text-align: center;">
            <img class="img"  src="@/icons/qualificationImage2.jpg" @click="onClick(1)"/>
        </div>
        <div class="text">信息系统安全等级保护备案证明</div>
        <div style="text-align: center;">
            <img class="img"  src="@/icons/qualificationImage3.jpg" @click="onClick(2)"/>
        </div>
      <div class="text">云南第三方药师远程服务平台确认件</div>
      <div style="text-align: center;">
          <img class="img2"  src="@/icons/qualificationImage4.jpg" @click="onClick(3)"/>
      </div>
  </div>
</template>
<script>
import image1 from "@/icons/qualificationImage1.jpg"
import image2 from "@/icons/qualificationImage2.jpg"
import image3 from "@/icons/qualificationImage3.jpg"
import image4 from "@/icons/qualificationImage4.jpg"
import { getCookie } from '@/utils/auth'
import { ImagePreview } from 'vant';
export default {
  data() {
    return {
        images: [
            image1,
            image2,
            image3,
            image4,
        ],
    }
  },
  methods: {

    /**
    * @description: 长按保存图片
    */
    onClick(index) {
        const client = getCookie('native_client') || ''
        if (client == 'android'){
            ImagePreview({
                images: this.images, // 预览图片的那个数组
                showIndex:true,
                loop:false,
                startPosition:index, // 指明预览第几张图
                closeable: true,
            })
        }
    },

    onClickLeft() {
     this.$router.push('/course')
    }
  }
}
</script>
<style scoped>

.service-page {
  width: 375px;
  height: 100vh;
  background: #ffffff;
  position: relative;
}

.marginTop {
  margin-top: 10px;
  font-size: 14px;
}
.text{
    font-size: 14px;
    margin-top: 10px;
    margin-left: 10px;
    font-weight: bold;
}
.img{
  width: 190px;
  height: 140px;
  margin-top: 10px;
}

.img2{
    width: 190px;
    /*height: 140px;*/
    margin-top: 10px;
}

.big-img{
  width: 90vw;
  height: 66vw;
}





</style>
